import { Box, Grid, Typography } from "@mui/material";
import {
    EnhancedButtonPrimeReact,
    EnhancedButtonPrimeReactSeverity,
    EnhancedDropDownRHFWithLabel,
    FieldLayout,
    ITest,
    LabelPosition,
    RHookFormDatePicker,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

interface IClassLocatIonDepartmentInfoFieldsPanel extends ITest {
    classDDL: any;
    locationDDL: any;
    departmentDDL: any;
}

export const ClassLocatIonDepartmentInfoFieldsPanel: FC<
    IClassLocatIonDepartmentInfoFieldsPanel
> = ({ classDDL, locationDDL, departmentDDL }) => {

    return (
        <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ display: "flex" }}>
            <Grid size={{ xs: 6, sm: 6, md: 4, lg: 4, xl: 4 }}>
                <EnhancedDropDownRHFWithLabel
                    label="Class"
                    selectName="class"
                    testId="class"
                    labelPosition={LabelPosition.Top}
                    items={classDDL ?? []}
                    labelColumns={4}
                    fieldColumns={8}
                    showEmpty
                />

                <EnhancedDropDownRHFWithLabel
                    label="Location"
                    selectName="location"
                    testId="location"
                    labelPosition={LabelPosition.Top}
                    items={locationDDL ?? []}
                    labelColumns={4}
                    fieldColumns={8}
                    showEmpty
                />
                <EnhancedDropDownRHFWithLabel
                    label="Department"
                    selectName="department"
                    testId="department"
                    labelPosition={LabelPosition.Top}
                    items={departmentDDL ?? []}
                    labelColumns={4}
                    fieldColumns={8}
                    showEmpty
                />

                {/* <EnhancedButtonPrimeReact
                    label="Load"
                    severity={EnhancedButtonPrimeReactSeverity.Secondary} /> */}
            </Grid>

        </Grid>
    );
};
